export const ru = {
    'banner-archived': 'Архивация объявления',
    'banner-hide': 'Остановка объявления',
    'banner-show': 'Включение объявления',
    'banner-unarchived': 'Разархивация объявления',
    bannerNo: '№ объявления',
    broadmatch: 'Дополнительные релевантные фразы',
    'campaign-archived': 'Архивация кампании',
    'campaign-creation': 'Создание кампании',
    'campaign-hide': 'Остановка кампании',
    'campaign-show': 'Включение кампании',
    'campaign-unarchived': 'Разархивация кампании',
    campaignFinish: 'Дата окончания кампании',
    campaignStart: 'Дата начала кампании',
    changes: 'Параметры изменения',
    cid: '№ кампании',
    demography: 'Корректировки ставок по полу и возрасту',
    disabledDomains: 'Запрещённые площадки',
    disabledIps: 'Запрещённые IP-адреса',
    disabledSsp: 'Запрещённые внешние сети',
    extendedGeo: 'Расширенный географический таргетинг',
    groupNo: '№ группы',
    minusWords: 'Минус-фразы для кампании',
    mobileMultipliers: 'Корректировки ставок для мобильных',
    network: 'Настройки в сетях',
    objects: 'Объекты',
    perfomanceMultipliers: 'Корректировки ставок для смарт-объявлений',
    regions: 'Регион показов',
    restrictFrequency: 'Ограничение частоты показов',
    retargeting: 'Корректировки ставок для целевой аудитории',
    settings: 'Настройки',
    statuses: 'Статусы',
    strategy: 'Стратегия',
    timeTargeting: 'Временной таргетинг',
    userName: 'Кто изменил',
    videoMultipliers: 'Корректировки ставок для видеодополнений'
};
